import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  MenuItem,
  Tooltip,
  TextField,
  Typography,
} from '@material-ui/core';


import { useForm } from 'react-hook-form';

import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";

import { monthCalendar } from '../../constants/models/monthCalendar';

import '../../styles/style.scss';
import usersService from '../../services/users.service';
import BillingStatementService from '../../services/billing-statement.service';


export const BillingStatementScreen = () => {

  const { isLoggedIn, user } = useSelector(state => state.auth);
  const an8Logged = isLoggedIn ? user.noCustomer : '---';

  const dispatch = useDispatch();
  const history = useHistory();

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  //const todayDate = new Date();

  const [customers, setCustomers] = useState({
    isLoading: true,
    isDisabled: true,
    data: []
  });

  const [yearsPayment, setYearsPayment] = useState({
    isLoading: false,
    isDisabled: true,
    data: []
  });

  const [montPayment, setMonthPayment] = useState([]);

  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null)
  const [isDownloadFile, setIsDownloadFile] = useState(false);
  const [isLoadingMonth, setIsLoadingMonth] = useState(false);
  const validationSchema = Yup.object().shape({
    an8: Yup.string().required('Cliente es requerido').default(null),
    year: Yup.string().required('Año es requerido').default(null),
    month: Yup.string().required('Mes es requerido').default(null),
  }, []);

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });

  /**
   * Recuperar filtros
   */
  useEffect(() => {
    getCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Recupera la lista de clientes
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
  const getCustomers = () => {

    setCustomers({
      isLoading: true,
      isDisabled: true,
      data: []
    })
    usersService.getCustomerAssociatesByAN8(an8Logged).then((response) => {
      let customersResponse = response;

      setCustomers({
        isLoading: false,
        isDisabled: false,
        data: customersResponse
      });
    }).catch((error) => {
      console.log(error);
      setCustomers({
        isLoading: false,
        isDisabled: false,
        data: ['']
      });

      if (sessionDifference > Number(tokenExpired)) {
        sesionExpired(dispatch, history);
      } else {
        actionErrorConnection(error, 'Error al recuperar clientes.');
      }
    });
  }

  /**
   * Recupera la lista de años por clientes
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */

  const getYears = (an8) => {
    setYearsPayment({
      isLoading: true,
      isDisabled: true,
      data: []
    });
    BillingStatementService.getYears(an8).then((response) => {
      setYearsPayment({
        isLoading: false,
        isDisabled: false,
        data: response
      });
      setIsLoadingFilters(false);
    }).catch((error) => {
      console.log(error);
      setYearsPayment({
        isLoading: false,
        isDisabled: false,
        data: []
      });
      setIsLoadingFilters(false);
      setIsLoadingMonth(false);
      if (sessionDifference > Number(tokenExpired)) {
        sesionExpired(dispatch, history);
      } else {
        actionErrorConnection(error, 'Error al recuperar años.');
      }
    });
  }

  /** 
   * Recupera el an8 seleccionado y realiza busqueda de años
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   * 
  */
  const onCustomerChange = () => {
    const params = getValues();
    if (params.an8 && params.an8 !== '') {
      setIsLoadingFilters(true);
      getYears(params.an8);
    }
  }

  /** 
   * Recupera el año seleccionado y realiza busqueda de meses
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   * 
  */
  const onYearChange = () => {
    setMonthPayment([])
    setValue("month", null);
    const params = getValues();
    const monthMap = new Map() // nuevo mapa para almacenar todas los meses obtenidos del servidor.
    setIsLoadingMonth(true)
    BillingStatementService.getMonths(params.an8, params.year).then((response) => {
      response.map((el)=> monthMap.set(el)) // Definir keys de meses sus values son undefined
      const arr = monthCalendar.filter(({name})=>  monthMap.has(name.toUpperCase()) ); // retornar todos los objeto meses de month calendar
      //que contengan el mes en el monthMap
      setMonthPayment(arr)
      setIsLoadingMonth(false);
    }).catch((error) => {
      console.log(error)
      setIsLoadingMonth(false);
      if (sessionDifference > Number(tokenExpired)) {
        sesionExpired(dispatch, history);
      } else {
        actionErrorConnection(error, 'Error al recuperar años.');
      }
    })
    
    // Se comenta para implementar el nuevo servicio de meses
    // let monthArrayChange = monthCalendar;
    //
    // if(params.year >= todayDate.getFullYear()){
    //   monthArrayChange = monthCalendar.filter(({numberMount})=>Number(numberMount) <= todayDate.getMonth()+1);
    // }
    // console.log(monthArrayChange,"MonthArrayChange")
    // console.log(monthCalendar,"monthCalendar")
  }

  /**
   * inicia la descarga del archivo
   * @param {string} typeFile - diferenciador de archivo a descargar
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
  const downloadFile = (typeFile) => {

    setIsDownloadFile(true);
    const params = getValues();
    const dateComplete = `${params.month}/${params.year} `
    const dataToSend = {
      an8: params.an8,
      date: dateComplete,
      format: typeFile
    }
    getDownloadPdf(dataToSend);
  };

  /**
   * inicia descarga de pdf
   * @param {object} dataToSend - filtros de busqueda de estado de cuenta
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
  const getDownloadPdf = (dataToSend) => {
    BillingStatementService.downloadBillingStatement(dataToSend).then(
      (response) => {

        const byteString = window.atob(response.data.split(',')[1]);
        const mimeString = response.data.split(',')[0].split(':')[1].split(';')[0];

        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }

        const dataBlob = new Blob([ab], { type: mimeString });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(dataBlob, `${response.name}.pdf`);
          return
        }

        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${response.name}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setIsDownloadFile(false);
      },
      (error) => {
        console.log(error)

        if (sessionDifference > Number(tokenExpired)) {
          sesionExpired(dispatch, history);
        } else {
          actionErrorConnection(error, 'Error al descargar archivo pdf');
        }
        setIsDownloadFile(false);
      });
    console.log('descargar archivo pdf');
  }

  return (
    <>
      <div className="container-fluid p-0 m-0">
        <div className="row flex-nowrap p-0 m-0">
          <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
            <SidebarMenu />
          </div>
          <div className="col p-0 ms-1 me-1">
            <NavTopMenu />
            <div className="container ps-3 pe-3 container-size">
              <div className="row base-container ">
                <div className="col-12 border-title text-title pt-2 pb-2 ps-4">
                  <span className="h4">Estados de cuenta</span>
                </div>
                <div className="col-12 pt-1 pb-3 ps-2 pe-2">
                  <div className="row ">
                    <div className="col-12 ">
                      <div className="w-100 d-flex justify-content-end">
                        {(customers.isLoading || yearsPayment.isLoading || isLoadingMonth )  &&
                          <Tooltip title="Cargando filtro..." placement="top-start" arrow>
                            <div className="custom-icon-loading me-1">
                              <i className="fas fa-spinner fa-spin"></i>
                            </div>
                          </Tooltip>
                        }
                        
                        <Tooltip title="Filtrar" placement="top-start" arrow>
                          <button className="btn custom-btn-icons"
                            type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseExample" aria-expanded="false"
                            aria-controls="collapseExample">
                            <i className="fas fa-filter"></i>
                          </button>
                        </Tooltip>
                      </div>
                      <div className="collapse show" id="collapseExample">
                        <div className="filter-continer">
                          <div className="container mt-3">
                            <form className="row">
                              <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                  select
                                  required
                                  id="an8"
                                  name="an8"
                                  label="Num. cliente"
                                  variant="outlined"
                                  size="small"
                                  disabled={customers.isDisabled || customers.isLoading}
                                  fullWidth
                                  defaultValue={''}
                                  {...register('an8')}
                                  onBlur={onCustomerChange}
                                >
                                  <MenuItem value="">Seleccionar cliente</MenuItem>
                                  {customers.data.map(({ noCustomer, name }) => (
                                    <MenuItem key={noCustomer} value={noCustomer}>
                                      {noCustomer} - {name}
                                    </MenuItem>
                                  ))}
                                </TextField>
                                <Typography variant="inherit" color="error">
                                  {errors.an8?.message}
                                </Typography>
                              </div>
                              <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                  select
                                  required
                                  id="year"
                                  name="year"
                                  label="Año"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  {...register('year')}
                                  defaultValue={""}
                                  disabled={yearsPayment.isDisabled || yearsPayment.isLoading}
                                  onBlur={onYearChange}
                                  
                                >
                                  <MenuItem value="">Seleccionar año</MenuItem>
                                  {yearsPayment.data?.length === 0 && <MenuItem value="">Sin registros</MenuItem>}
                                  {yearsPayment.data?.map((option) => (
                                    <MenuItem key={option} value={option}>
                                      {option}
                                    </MenuItem>
                                  ))}
                                </TextField>
                                <Typography variant="inherit" color="error">
                                  {errors.year?.message}
                                </Typography>
                              </div>
                              <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                  select
                                  required
                                  id="month"
                                  name="month"
                                  label="Mes"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  {...register('month')}
                                  defaultValue={""}
                                  onChange={(e)=>setSelectedMonth(e.target.value)}
                                  disabled={yearsPayment.isDisabled || yearsPayment.isLoading || !yearsPayment?.data?.length > 0  || !montPayment.length > 0 || isLoadingMonth  }
                                >
                                      <MenuItem value="">Seleccionar mes</MenuItem>
                                        {montPayment.map((option) => (
                                          <MenuItem key={option.id} value={option.numberMount}>
                                            {option.name}
                                          </MenuItem>
                                      ))}
                                </TextField>
                                <Typography variant="inherit" color="error">
                                  {errors.month?.message}
                                </Typography>
                              </div>
                              <div className="col-12 w-100 d-flex justify-content-end">
                                {
                                  isDownloadFile ?
                                    <Tooltip title="Descargando..." placement="top-start" arrow>
                                      <div className="custom-icon-loading me-1">
                                        <i className="fas fa-spinner fa-spin"></i>
                                      </div>
                                    </Tooltip>
                                    :
                                    <Tooltip title="Descargar" placement="top-start" arrow>
                                      <div>
                                        <button
                                          className="btn custom-btn-icons"
                                          disabled={isLoadingFilters || isLoadingMonth || yearsPayment.isLoading || !selectedMonth }
                                          onClick={handleSubmit(()=>downloadFile('pdf'))}
                                          type='submit'
                                        >
                                          <i className="fas fa-download"></i>
                                        </button>
                                      </div>
                                    </Tooltip>
                                }
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
